module.exports = __webpack_public_path__ + "static/5-2b5f12ad847ea992cf01f557d17eea6b.jpg";